export interface ModulePermissions {
  read: string
  create?: string
  update?: string
  delete?: string
}

export const MODULE_PERMISSIONS = {
  users: {
    read: 'ReadUsers',
    create: 'CreateUsers',
    update: 'UpdateUsers',
    delete: 'DeleteUsers'
  },
  roles: {
    read: 'ReadRoles',
    create: 'CreateRoles',
    update: 'UpdateRoles',
    delete: 'DeleteRoles'
  },
  companies: {
    read: 'ReadCompanies',
    create: 'CreateCompanies',
    update: 'UpdateCompanies',
    delete: 'DeleteCompanies'
  },
  societies: {
    read: 'ReadSocieties',
    create: 'CreateSocieties',
    update: 'UpdateSocieties',
    delete: 'DeleteSocieties'
  },
  projects: {
    read: 'ReadProjects',
    create: 'CreateProjects',
    update: 'UpdateProjects',
    delete: 'DeleteProjects'
  },
  typeProperties: {
    read: 'ReadTypeProperties',
    create: 'CreateTypeProperties',
    update: 'UpdateTypeProperties',
    delete: 'DeleteTypeProperties'
  },
  properties: {
    read: 'ReadProperties',
    create: 'CreateProperties',
    update: 'UpdateProperties',
    delete: 'DeleteProperties'
  },
  agencies: {
    read: 'ReadAgencies',
    create: 'CreateAgencies',
    update: 'UpdateAgencies',
    delete: 'DeleteAgencies'
  },
  representants: {
    read: 'ReadRepresentants',
    create: 'CreateRepresentants',
    update: 'UpdateRepresentants',
    delete: 'DeleteRepresentants'
  },
  states: {
    read: 'ReadStates',
    create: 'CreateStates',
    update: 'UpdateStates',
    delete: 'DeleteStates'
  },
  workflows: {
    read: 'ReadWorkflows',
    create: 'CreateWorkflows',
    update: 'UpdateWorkflows',
    delete: 'DeleteWorkflows'
  },
  professions: {
    read: 'ReadProfessions',
    create: 'CreateProfessions',
    update: 'UpdateProfessions',
    delete: 'DeleteProfessions'
  },
  flowDefinitions: {
    read: 'ReadFlowDefinitions',
    create: 'CreateFlowDefinitions',
    update: 'UpdateFlowDefinitions',
    delete: 'DeactivateFlowDefinitions'
  },
  /**
   * Créditos no tiene `delete`: un expediente no se borra, se cancela — y cancelarlo es una
   * transición del proceso, no una baja. `create` es abrirlo a mano (el otro camino es el cron) y
   * `update` es el trabajo de la checklist; las decisiones que pesan —avanzar de etapa, elegir la
   * modalidad, avisarle al cliente— tienen permiso propio y no entran en este mapa CRUD.
   *
   * `read` es el permiso BASE (`ReadCredits`) y no `ReadAllCredits`: este mapa declara qué abre el
   * módulo, y desde la separación de alcances lo que lo abre es la cartera propia. `ReadAllCredits`
   * ensancha esa lectura a toda la organización y por eso no entra en el CRUD.
   */
  credits: {
    read: 'ReadCredits',
    create: 'StartCreditProcess',
    update: 'UpdateCreditChecklist'
  }
} as const satisfies Record<string, ModulePermissions>
